var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("cm-service-popups"),
      _vm._v(" "),
      _c("cm-service-switcher-popup", { attrs: { closeButton: true } }),
      _vm._v(" "),
      _vm.changePasswordPopup
        ? _c("cm-change-password-popup", {
            staticClass: "z-10080",
            attrs: { data: _vm.changePasswordPopupData },
            on: {
              close: function ($event) {
                _vm.changePasswordPopup = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("cm-user-reset-password", { attrs: { closeButton: true } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }